// extracted by mini-css-extract-plugin
module.exports = {"productName":"styles_productName__XOUN9","productsTypes":"styles_productsTypes__ky9Ry","expandCollapse":"styles_expandCollapse__3W1Fq"};